import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { Channel } from '../../types/channel'
import ChannelRow from './ChannelRow'
import UserRowSkeleton from './ChannelRow.skeleton'
import useStyles from './styles/ChannelsTable.styles'

interface ChannelListProps {
  data: Channel[]
  loading: boolean
  reloadData: () => void
}
export const ChannelsTable: React.FC<ChannelListProps> = ({
  data,
  loading,
  reloadData
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Type')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <UserRowSkeleton
                key={`channel-skeleton${item}${index.toString()}`}
              />
            ))
        : data?.map((singleChannel) => (
            <Fade
              in
              timeout={600}
              key={singleChannel.basicDetails.displayChannelCode}>
              <div data-cy="tableRowChannelData">
                <ChannelRow
                  key={singleChannel.basicDetails.displayChannelCode}
                  data={singleChannel}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
